import { render } from "./CleanupPage.vue?vue&type=template&id=9f0d44fc&scoped=true"
import script from "./CleanupPage.vue?vue&type=script&lang=js"
export * from "./CleanupPage.vue?vue&type=script&lang=js"

import "./CleanupPage.vue?vue&type=style&index=0&id=9f0d44fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f0d44fc"]])

export default __exports__